module.exports = __webpack_public_path__ + "static/media/talking.b9e8bd2b.svg";